(function ($) {
	'use strict';

	$(function () {
		$('.js-hero-heading').each(function () {
			const carousel = $(this);
			const layout = carousel.data('layout');
			const sliderEl = $('.swiper', carousel)[0];

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				slidesPerView: 1,
				loop: true,
				autoHeight: true,
				effect: 'fade',
				speed: 800,
				autoplay: {
					delay: 2000,
					disableOnInteraction: false,
				},
			});
		});
	});
})(jQuery);
